module.exports = __webpack_public_path__ + "img/honor (10).0eb73467.jpg";